export { default } from "./AppDialog";

export type { AppDialogProps } from "./AppDialog";
